import { Component, OnInit } from '@angular/core';

import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/api';

import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class MessagesComponent implements OnInit {

  now: string = new Date().toISOString();
  show_popup = false;
  loading: boolean;
  headers: any[] = [
  { title: 'Bericht', class: 'th--normal' },
  { title: 'Status', class: 'th--small' },
  { title: 'Doelgroep', class: 'th--normal' },
  { title: 'Bezorgtijd', class: 'th--small' },
  { title: '', class: 'th--edit' },
  ];
  message: any;


  constructor(private dataService: DataService, private messageService: MessageService, private confirmService: ConfirmationService) { }

  ngOnInit() {
    this.getMessages();
  }

  getMessages() {
    this.loading = true;
      this.dataService.get('message', true).subscribe(
        (result: any) => {
          this.loading = false;
          this.dataService.messages = result;
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
  }

  editMessage(message) {
    this.message = message;
    this.show_popup = true;
  }

  cancelMessage(message) {
    this.confirmService.confirm({
        message: 'Weet je zeker dat je dit bericht wil annuleren?',
        accept: () => {
          const resource = 'message';
          const payload = message;
          payload.is_canceled = true;
          this.dataService.put(resource, payload).subscribe(
            (result) => {
              console.log(result);
            }
          );
        }
    });
  }

  createMessage() {
    this.show_popup = true;
  }

  onClose(event) {
    this.message = undefined;
    this.show_popup = false;
  }

  onNotify(event) {
    this.presentMessage(event.type, event.title, event.body);
  }

  presentMessage(type: string, title: string, body: string) {
    this.messageService.add({severity: type, summary: title, detail: body});
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/messages/messages.component.ts